import { Box, Skeleton } from "@mui/material";
import { SkeletonLinkPreview } from "./SkeletonLinkPreview";

export const SkeletonAnnouncementList = () => (
  <Box sx={{ width: '100%', padding: 2 }}>
    {[...Array(5)].map((_, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: 2,
          justifyContent: index % 2 === 0 ? 'flex-end' : 'flex-start',
        }}
      >
        {index % 2 === 0 ? null : <Skeleton variant="circular" width={30} height={30} sx={{ marginRight: 2 }} />}
        <Box sx={{ width: '100%' }}>
          <SkeletonStamp isOwnMessage={index % 2 === 0} />
          <SkeletonLinkPreview isOwnMessage={index % 2 === 0} />
          <SkeletonChatBubble isOwnMessage={index % 2 === 0} />
        </Box>
      </Box>
    ))}
  </Box>
);
const SkeletonStamp = ({ isOwnMessage }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: isOwnMessage ? 'flex-end' : 'flex-start' }}>
    <Skeleton
      variant="text"
      width="30%"
      height={20}
      sx={{
        marginBottom: 1,
      }}
    />
  </Box>
);


const SkeletonChatBubble = ({ isOwnMessage }) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: 3,
      backgroundColor: isOwnMessage ? '#EEF5FF' : '#EEF5FF',
      padding: '8px 12px',
      width: '30vw',
      maxWidth: '85%',
      wordWrap: 'break-word',
      marginLeft: isOwnMessage ? 'auto' : 0,
      marginRight: isOwnMessage ? 0 : 'auto',
      borderTopRightRadius: isOwnMessage ? 0 : null,
      borderTopLeftRadius: isOwnMessage ? null : 0,
      boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
      marginBottom: 1,
    }}
  >
    <Skeleton variant="text" width="100%" height={40} />
  </Box>
);
